import EtaConfiguracionesForm from "./EtaConfiguracionesForm";
export default EtaConfiguracionesForm;